import { Reveal, Eyebrow, ArrowLink } from "./Reveal";

const STADIUM_IMG =
  "https://images.unsplash.com/photo-1647849402208-01775e9c9fb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxzdGFkaXVtJTIwZXh0ZXJpb3IlMjBzdHJ1Y3R1cmV8ZW58MHx8fHwxNzkxODMzMDI2fDA&ixlib=rb-4.1.0&q=85";

export const SportsAdvisory = () => (
  <section data-testid="sports-advisory-section" className="relative py-28 lg:py-44">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <Eyebrow>Sports Investments</Eyebrow>
            <h2 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-[#1F1E1B] leading-[1.08]">
              The evolving ownership of <span className="italic">global sport.</span>
            </h2>
            <p className="mt-8 max-w-xl text-base sm:text-lg font-light leading-relaxed text-[#1F1E1B]/85">
              Professional sport has become an increasingly significant area of interest for private
              capital, institutional investors and international family offices.
            </p>
            <p className="mt-6 max-w-xl text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              PJG's sports investment advisory focus encompasses ownership transactions, strategic
              investments and capital partnerships across professional sport — with a particular focus on
              professional football.
            </p>
            <div className="mt-10">
              <ArrowLink to="/sports-investments" testid="sports-feature-link">
                Explore Sports Investments
              </ArrowLink>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="relative">
            <div className="relative aspect-[4/3] w-full overflow-hidden border border-[#E3E0D8]">
              <img
                src={STADIUM_IMG}
                alt="World-class stadium architecture with lattice facade"
                loading="lazy"
                className="w-full h-full object-cover grayscale contrast-110 brightness-[0.92]"
              />
              <span className="absolute top-4 left-4 w-6 h-6 border-t border-l border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute top-4 right-4 w-6 h-6 border-t border-r border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute bottom-4 left-4 w-6 h-6 border-b border-l border-[#F6F4F0]/80" aria-hidden="true" />
              <span className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#F6F4F0]/80" aria-hidden="true" />
            </div>
            <div className="absolute -bottom-6 -left-4 lg:-left-8 bg-[#1F1E1B] px-6 py-5">
              <p className="font-sans text-[10px] uppercase tracking-[0.28em] text-[#A8A49B]">Dedicated Practice</p>
              <p className="mt-1 font-serif text-lg text-[#F6F4F0]">Football & Sport</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
